import * as React from 'react';

import { Viewport, ViewSmall, ViewLarge } from 'bernie-view';
import { UitkTextSkeleton } from 'uitk-react-skeleton';
import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';

export const ListingSkeleton = () => (
  <li data-test-id="listing-skeleton">
    <UitkCardAloha className="all-b-margin-three">
      <UitkCardAlohaContentSection>
        <Viewport>
          <ViewSmall>
            <>
              <UitkTextSkeleton className="all-b-margin-three" animation={true} width={30} />
              <UitkTextSkeleton animation={true} width={14} className="all-b-margin-twelve" />
            </>
          </ViewSmall>
          <ViewLarge>
            <>
              <UitkTextSkeleton className="all-b-margin-three" animation={true} width={18} />
              <UitkTextSkeleton animation={true} width={8} className="all-b-margin-twelve" />
            </>
          </ViewLarge>
        </Viewport>
      </UitkCardAlohaContentSection>
    </UitkCardAloha>
  </li>
);
